import {
  CreditSummaryEntity,
  PaginatedResponse,
  ListParams,
} from "../entities/CreditSummaryEntity";
import { CreditsRepository } from "../repositories/CreditsRepository";

export class GetVendorOutstandingBillsUseCase {
  constructor(private repository: CreditsRepository) {}

  async execute(
    params: ListParams
  ): Promise<PaginatedResponse<CreditSummaryEntity>> {
    return await this.repository.getVendorOutstandingBills(params);
  }
}
